import { Card } from "../../../components/Card";
import { useReports } from "../../praxis-play-dashboard/context/reports-context";
import { useNavigate } from "react-router-dom";
import { LottieLoading } from "../../../components/Loading/LottieLoading";
import { useApp } from "../../../services/app-context";
import { useAnalytics } from "../../../integrations/posthog/useAnalytics";
import { PRAXIS_PLAY_EVENTS } from "../../../integrations/posthog/events";
import { getPersonalityLabels, getPractitionerTypeMap } from "../../../services/utils";
import { CallCard } from "../../praxisplay-call-history/components/CallCard";
import { useMemo } from "react";

export function SessionLogs({
  data = [],
  title = "PraxisPlay Call Log",
  isLoadingReports,
}: {
  data?: any;
  title?: string;
  isLoadingReports?: boolean;
}) {
  const { captureEvent } = useAnalytics();
  const { tenantProfile } = useApp();
  const { setSelectedReports } = useReports();
  const navigate = useNavigate();

  const practitionerTypeMap = useMemo(
    () => getPractitionerTypeMap(tenantProfile),
    [tenantProfile]
  );

  const handleSessionClick = (session: any) => {
    const hasEndReason = !!session?.endReason || !!session?.end_reason;
    if (hasEndReason) return;
    setSelectedReports(session);
    captureEvent(PRAXIS_PLAY_EVENTS.DASHBOARD_QUICK_ACTION_TAPPED, {
      action: "reports",
      session_id: session.sessionID,
      button_location: "dashboard",
    });
    navigate(`/praxisplay/session/${session.sessionID}`);
  };

  return (
    <Card className="lg:min-w-[430px] !p-[18px] h-full">
      <div className="flex justify-between items-center mb-6 px-[3px]">
        <div className="text-text-primary text-[clamp(13px, 1.5vw, 16px)] font-semibold">{title}</div>
        <div>
          <button
            className="text-headerPrimary hover:text-headerPrimary/80 text-[clamp(13px,1.5vw,16px)] font-semibold cursor-pointer"
            onClick={() => {
              navigate("/call-history");
              captureEvent(PRAXIS_PLAY_EVENTS.DASHBOARD_QUICK_ACTION_TAPPED, {
                action: "reports",
                session_id: "view_all",
                button_location: "dashboard",
              });
            }}
          >
            VIEW ALL
          </button>
        </div>
      </div>
      <div className="flex flex-col gap-2.5 px-[3px] mb-4 overflow-y-auto h-[calc(100vh-570px)]">
        {isLoadingReports && data.length === 0 ? (
          <LottieLoading className="!h-full" />
        ) : (
          <>
            {
              data?.map((session, index) => {
                const isClickable = !session?.endReason && !session?.end_reason;

                return (
                <CallCard
                  key={session?.sessionID || index}
                  session={session}
                  practitionerTypeLabel={
                    practitionerTypeMap[session.practitionerType] ||
                    session.practitionerType
                  }
                  personalityLabels={getPersonalityLabels(session.personalityType, tenantProfile)}
                  onClick={!isClickable ? undefined : () => handleSessionClick(session)}
                  clickable={isClickable}
                />
              )})
            }
          </>
        )}
      </div>
    </Card>
  );
}
